import PeopleManagement from './PeopleManagement';
import { useState } from 'react';
import AddAdmin from './AddAdmin';

export default function PeopleModal({ onToggle }: { onToggle: () => void }) {
  const [isAdd, setIsAdd] = useState(false);
  const addAdminHandler = () => {
    setIsAdd(true);
  };

  const cancelAddHandler = () => {
    setIsAdd(false);
  };

  return (
    <div className="min-h-[500px] w-[400px] shadow-regular rounded-xl bg-white">
      {isAdd ? (
        <AddAdmin onBack={cancelAddHandler} />
      ) : (
        <PeopleManagement onToggle={onToggle} onAddAdmin={addAdminHandler} />
      )}
    </div>
  );
}
